// src/client/renderer/shaders/water.ts
import * as THREE from 'three';
import type { ShaderFactory } from './types';
import { VERTEX as WATER_VERTEX, FRAGMENT as WATER_FRAGMENT } from './water.glsl';

export interface WaterUniforms {
  uTime: THREE.IUniform<number>;
  /** Default: (0.0, 0.30, 0.55). */
  uDeepColor: THREE.IUniform<THREE.Color>;
  /** Default: (0.40, 0.85, 0.95). */
  uShallowColor: THREE.IUniform<THREE.Color>;
  /** Fresnel power exponent. Default: 3.0. */
  uFresnelPower: THREE.IUniform<number>;
  /** Wave amplitude (vertex Y disp). Default: 0.05. */
  uWaveAmplitude: THREE.IUniform<number>;
  /** Wave frequency. Default: 4.0. */
  uWaveFrequency: THREE.IUniform<number>;
}

export const createWaterShader: ShaderFactory = () => {
  const uniforms: WaterUniforms = {
    uTime: { value: 0 },
    uDeepColor: { value: new THREE.Color(0.0, 0.3, 0.55) },
    uShallowColor: { value: new THREE.Color(0.4, 0.85, 0.95) },
    uFresnelPower: { value: 3.0 },
    uWaveAmplitude: { value: 0.05 },
    uWaveFrequency: { value: 4.0 },
  };
  return new THREE.ShaderMaterial({
    uniforms: uniforms as unknown as Record<string, THREE.IUniform<unknown>>,
    vertexShader: WATER_VERTEX,
    fragmentShader: WATER_FRAGMENT,
    side: THREE.DoubleSide,
    transparent: true,
  });
};
